import { StyleColorSchemeType, StyleSizeType } from '@/ui-kit/styles/enums';
import { IconHintTooltipProperty } from '../enum';
import { IconType } from '@/ui-kit/components/icon/enums';

const IconHintTooltipProps = {
  props: {
    [IconHintTooltipProperty.Header]: {
      default: '',
      type: String,
    },
    [IconHintTooltipProperty.Message]: {
      default: '',
      type: String,
    },
    [IconHintTooltipProperty.IconType]: {
      type: String,
      default: IconType.QuestionCircle,
    },
    [IconHintTooltipProperty.IconColor]: {
      type: String,
      default: StyleColorSchemeType.Secondary,
    },
    [IconHintTooltipProperty.IconSize]: {
      type: String,
      default: StyleSizeType.Medium,
    },
  },
};

export default IconHintTooltipProps;
